import { CommonContentAssetFormEntity, CommonContentAssetEntity } from 'src/types'

export const CommonContentAssetTranslator = {
  toFormEntity: (entity: CommonContentAssetEntity): CommonContentAssetFormEntity => {
    return {
      name: entity.name,
      url: entity.externalLink,
      priority: entity.priority,
      fileSize: entity.fileSize,
    }
  },
}
